export default __webpack_public_path__ + "static/media/di6.ed358a1f.jpg";